export default __webpack_public_path__ + "static/media/element_88.65f69a9b.webp";